import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
  name: "name"
})
export class NamePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (typeof value !== "object" || !value.name) {
      return null
    }
    if (typeof value.name === "string") {
      return value.name
    }
    if (typeof value.name === "object") {
      if (value.name.display) {
        return value.name.display
      }
      return value.name.given
    }
    return null
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/name.pipe.ts